/**
 * Interrupteur du companion sante (Tauri), carte n° 165.
 *
 * `NEXT_PUBLIC_COMPANION_SANTE_ENABLED=true` : le front sonde le companion sante, l'appaire, lui
 * confie la session Care et affiche son scan Vitale. Toute autre valeur, ou l'absence de la
 * variable (prod, staging) : aucun appel vers `127.0.0.1:31001`, aucun appairage, aucun panneau, et
 * les clients INSi, DMP et Web-PS appellent le companion Electron comme avant.
 *
 * Lu a l'appel, pas au chargement du module : Next remplace la variable au build, et les tests
 * peuvent la poser avant chaque cas. Module sans dependance, pour etre importe depuis le shell
 * sans y charger le transport.
 */
export const isHealthCompanionEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_COMPANION_SANTE_ENABLED === 'true'

/**
 * Interrupteur de l'espace sante (carte n° 34), reexporte par `lib/sante/santeConfig.ts`.
 *
 * Pose ici, et non dans `santeConfig`, parce que le menu Care (`getFrontOfficeCarePharmacien`)
 * le lit et fait partie du shell : un module de plus y depasserait le budget
 * (`scripts/check-shell-budget.cjs`, carte n° 225). Memes regles que ci-dessus : lu a l'appel,
 * sans dependance. `NEXT_PUBLIC_SANTE_ENABLED=true` et `NEXT_PUBLIC_SANTE_URL` renseignee : menu
 * et appels ; toute autre valeur ou une adresse absente : ni menu, ni appel.
 */
export const isSanteSpaceEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_SANTE_ENABLED === 'true' && getSanteUrl() !== ''

/** Adresse du service sante, sans barre finale (ex: `https://sante.pharmedigroup.com`). */
export const getSanteUrl = (): string =>
  (process.env.NEXT_PUBLIC_SANTE_URL || '').replace(/\/+$/, '')
